module.exports = __webpack_public_path__ + "static/media/dcf.783e82b1.jpg";